import { Text } from '@shared/ui/antd';
import type { CSSProperties, FC, ThHTMLAttributes } from 'react';
import styles from './thead-cell-text.module.scss';

export type THeadCellTextProps = ThHTMLAttributes<HTMLHeadingElement> & {
  width?: number;
  textStyle?: CSSProperties;
};

export const THeadCellText: FC<THeadCellTextProps> = ({ children, width, textStyle, ...props }) => (
  <th {...props} style={{ width, ...props.style }}>
    <Text variant="sm" fontWeight={500} className={styles.root} style={textStyle}>
      {children}
    </Text>
  </th>
);
